import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogData} from '../export-file-list/export-file-list.component';

@Component({
  selector: 'app-download-dialog',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.scss']
})
export class DownloadDialogComponent {
  progress = 0;
  done: string;
  @ViewChild('btnContainer', {static: false}) private btnContainer: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<DownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.done = 'done';
  }

  download() {
    this.progress = 5;
    const children = this.btnContainer.nativeElement.children;
    for (let i = 0; i < children.length; i++) {
      setTimeout(() => children[i].click(), 1400 * i);
    }
    setTimeout(() => this.dialogRef.close('auto close'), 1400 * children.length);
  }

  start(i: number, t: number) {
    const c = i + 1;
    console.log('Downloading file ' + c + ' of ' + t);
    this.progress = Math.floor(100 * (c / t));
  }

}

